// Static product catalog for NBMT Trading Co.

export const CATEGORIES = [
  { id: "basmati", label: "Basmati Rice" },
  { id: "non-basmati", label: "Non-Basmati Rice" },
  { id: "wheat", label: "Wheat" },
  { id: "flour", label: "Flour" },
  { id: "corn", label: "Yellow Corn Maize" },
  { id: "pulses", label: "Pulses" },
  { id: "sugar", label: "Sugar" },
  { id: "oil", label: "Edible Oil" },
  { id: "salt", label: "Salt" },
  { id: "sesame", label: "Sesame Seeds" },
  { id: "pasta", label: "Pasta & Noodles" },
  { id: "beverages", label: "Beverages" },
  { id: "confectionery", label: "Confectionery" },
  { id: "biscuits", label: "Biscuits" },
  { id: "molasses", label: "Molasses" },
  { id: "spices", label: "Spices & Masala" },
  { id: "dates", label: "Dates" },
  { id: "produce", label: "Fresh Produce" },
  { id: "grocery", label: "Grocery" },
];

const RICE_IMG = "https://images.pexels.com/photos/36346840/pexels-photo-36346840.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";
const RICE_IMG2 = "https://images.pexels.com/photos/7851798/pexels-photo-7851798.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";
const WHITE_RICE = "https://images.pexels.com/photos/6086556/pexels-photo-6086556.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";
const BROKEN_RICE = "https://images.pexels.com/photos/8108170/pexels-photo-8108170.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";
const SALT_IMG = "https://images.pexels.com/photos/9974508/pexels-photo-9974508.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";
const REFINED_SALT = "https://images.pexels.com/photos/7779878/pexels-photo-7779878.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";
const WHEAT_IMG = "https://images.pexels.com/photos/54084/wheat-grain-agriculture-seed-54084.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";
const CORN_IMG = "https://images.pexels.com/photos/30204262/pexels-photo-30204262.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";
const SESAME_IMG = "https://images.pexels.com/photos/7420888/pexels-photo-7420888.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";

const GEN = "https://static.prod-images.emergentagent.com/jobs/a8718520-b299-4cb9-b5ef-f4cec80a7b7c/images/";
const IMG_SUGAR = `${GEN}e9f46501b0b89866250d176a7e3769d86c715c22ef78cbd9b69a050c9af9b9df.jpeg`;
const IMG_OIL = `${GEN}ad561c91e4f3886b4c59c3f6a4ee4fc8b79d103a95f38cea123ea40f0e3c4aae.jpeg`;
const IMG_PULSES = `${GEN}cd92104b3e3904fe33af0abafce02300129c43bcbf386af8755268c76e7191ef.jpeg`;
const IMG_PASTA = `${GEN}a2cd4399bf06371371512430f1cd0147ee189d0b613cae07b0e50f7d647f767d.jpeg`;
const IMG_BEVERAGES = `${GEN}87a4c11088df19a6d028d93659b18bd468777af633c9726d16c11dfe9761aeff.jpeg`;
const IMG_CONFECTIONERY = `${GEN}12589996794a1e041e16b2b45935a4bc10c09d36d8c9433a25faa66847f79038.jpeg`;
const IMG_BISCUITS = `${GEN}a611b2842283b1039dc96be8660c1e9206477dc9dddd57773cd3768c2b4c103c.jpeg`;
const IMG_MOLASSES = `${GEN}72051d585b53e85b80851c59ef522883399b5d053755abf44e6d0d3d2cf220b3.jpeg`;
const IMG_FLOUR = `${GEN}8f446846a273dcc3ddee7ad2a9bcbe3dcde270be5e69060f07f3158176526d26.jpeg`;
const IMG_VERMICELLI = `${GEN}565e922d36c7bc55f1852db2ea0c989a1eed811387250be6da64e1feae9c21ca.jpeg`;
const IMG_PICKLES = `${GEN}b1d7726b2d3eb0409ddb3c5586b9ded67b8d5964c63b407ebc76dfaeed5e106c.jpeg`;
const IMG_SONA = `${GEN}615ff9151d389b79a752e522608a1d71c42af723f92c4171ad7ce4c9c2620023.jpeg`;
const IMG_IR64 = `${GEN}1a5e0920a1d4bc1b01b561672e7d6251e1e8d401646caabf43fbc9f074303f63.jpeg`;
const IMG_1718 = `${GEN}beefbb46d9daf83934d7e7fdd9ad0783db9e357b14e413533257a79390880ace.jpeg`;
const IMG_DATES = `${GEN}12c3ddf630f4072909bff73170bb1cbc549f8bfa7cfee4521fe104104ad85f4a.jpeg`;
const IMG_GLUCOSE = `${GEN}7c66746fcef8e0d225acdcfa55eb46798aa15151396a821acbb0edf8190be551.jpeg`;
const IMG_SPICES = `${GEN}4e4898a9c1036ebe84115ec9d4b1593d09f7f86eeb1374ff0ec731a94e735572.jpeg`;
const IMG_ONION = `${GEN}2fa25d9bb2368c014a3e1a76824820ae997a77bc25a29a0b8962da387dff1ad2.jpeg`;
const IMG_POTATO = `${GEN}efe476828ed2e47bc8d41b1f2cba444a382946caf3bd0cd650c93f8b618ba832.jpeg`;

const ricePack = [
  "5kg, 10kg, 25kg, 50kg bags",
  "PP woven, jute and non-woven bags",
  "Consumer retail packs available",
  "Private label under your own brand",
];
const bulkPack = [
  "25kg and 50kg PP bags",
  "Bulk jumbo bags",
  "Loose bulk in containers",
  "Private label available",
];
const retailPack = [
  "Assorted consumer retail packs",
  "Master cartons for wholesale",
  "Custom pack sizes on request",
  "Private label under your own brand",
];

export const PRODUCTS = [
  // ---------------- BASMATI ----------------
  {
    slug: "1121-sella-basmati-rice",
    name: "1121 Sella Basmati Rice",
    category: "basmati",
    origin: "India & Pakistan",
    tag: "Signature",
    image: RICE_IMG,
    short: "Extra long golden parboiled basmati with exceptional elongation.",
    description:
      "Our 1121 Sella Basmati is a premium, extra long grain parboiled rice prized for its distinctive aroma, non-sticky texture and remarkable elongation after cooking. Carefully aged and sorted for uniformity, it is a favourite across the Gulf and beyond.",
    specs: [
      { label: "Average Grain Length", value: "8.30 mm and above" },
      { label: "Type", value: "Parboiled (Sella)" },
      { label: "Moisture", value: "12% max" },
      { label: "Broken", value: "1% to 2% max" },
    ],
    packaging: ricePack,
  },
  {
    slug: "1121-steam-basmati-rice",
    name: "1121 Steam Basmati Rice",
    category: "basmati",
    origin: "India & Pakistan",
    tag: "Popular",
    image: RICE_IMG2,
    short: "Pure white steamed basmati with a clean, natural aroma.",
    description:
      "1121 Steam Basmati offers a bright white appearance and a soft, fluffy grain after cooking. Gently steamed to lock in the natural fragrance, it is well suited to fine dining and retail markets.",
    specs: [
      { label: "Average Grain Length", value: "8.30 mm and above" },
      { label: "Type", value: "Steamed" },
      { label: "Moisture", value: "12% max" },
      { label: "Broken", value: "1% max" },
    ],
    packaging: ricePack,
  },
  {
    slug: "1509-basmati-rice",
    name: "1509 Basmati Rice",
    category: "basmati",
    origin: "India & Pakistan",
    image: RICE_IMG2,
    short: "Aromatic long grain basmati with a balanced price point.",
    description:
      "The 1509 variety delivers the classic basmati aroma and slender long grain at an accessible price, making it a versatile choice for wholesalers and food service buyers.",
    specs: [
      { label: "Average Grain Length", value: "8.00 mm and above" },
      { label: "Type", value: "Raw / Sella / Steam" },
      { label: "Moisture", value: "12% max" },
      { label: "Broken", value: "2% max" },
    ],
    packaging: ricePack,
  },
  {
    slug: "1718-long-grain-basmati-rice",
    name: "1718 Long Grain Basmati Rice",
    category: "basmati",
    origin: "India",
    tag: "New",
    image: IMG_1718,
    short: "Extra long grain basmati from India with high elongation.",
    description:
      "1718 Basmati is a premium extra long grain variety from India, known for its slender grains, pleasant aroma and excellent post-cooking elongation. A refined choice for premium retail and food service, available raw, sella and steam.",
    specs: [
      { label: "Average Grain Length", value: "7.90 mm and above" },
      { label: "Type", value: "Raw / Sella / Steam" },
      { label: "Moisture", value: "12% max" },
      { label: "Broken", value: "1% to 2% max" },
    ],
    packaging: ricePack,
  },
  // ---------------- NON-BASMATI ----------------
  {
    slug: "indian-long-grain-white-rice",
    name: "Indian Long Grain White Rice",
    category: "non-basmati",
    origin: "India",
    image: WHITE_RICE,
    short: "Versatile Indian long grain rice for high volume markets.",
    description:
      "Long grain white rice sourced from India, offering consistent quality and value for importers, distributors and food processors across Africa, Asia and the Middle East.",
    specs: [
      { label: "Grain Type", value: "Long grain" },
      { label: "Type", value: "White / Parboiled" },
      { label: "Moisture", value: "14% max" },
      { label: "Broken", value: "5% / 25% options" },
    ],
    packaging: ricePack,
  },
  {
    slug: "sona-masoori-rice",
    name: "Sona Masoori Rice",
    category: "non-basmati",
    origin: "India",
    tag: "New",
    image: IMG_SONA,
    short: "Lightweight aromatic medium grain white rice from India.",
    description:
      "Sona Masoori is a lightweight, aromatic medium grain rice from India, prized for its soft texture and low starch content after cooking. A popular everyday staple across South India and the Middle East, well suited to retail and food service.",
    specs: [
      { label: "Grain Type", value: "Medium grain" },
      { label: "Type", value: "Raw / Steam" },
      { label: "Moisture", value: "14% max" },
      { label: "Broken", value: "5% max" },
    ],
    packaging: ricePack,
  },
  {
    slug: "ir-64-rice",
    name: "IR 64 Rice",
    category: "non-basmati",
    origin: "India",
    tag: "New",
    image: IMG_IR64,
    short: "Popular Indian long grain white rice for volume markets.",
    description:
      "IR 64 is a widely traded long grain non-basmati white rice from India, valued for its consistent quality, clean appearance and value pricing. A dependable choice for importers, distributors and food processors, available in a range of broken grades.",
    specs: [
      { label: "Grain Type", value: "Long grain" },
      { label: "Type", value: "White / Parboiled" },
      { label: "Moisture", value: "14% max" },
      { label: "Broken", value: "5% / 25% options" },
    ],
    packaging: ricePack,
  },
  {
    slug: "rice-glucose-syrup",
    name: "Rice Glucose Syrup",
    category: "non-basmati",
    origin: "Pakistan",
    tag: "New",
    image: IMG_GLUCOSE,
    short: "Clear rice-derived glucose syrup for food manufacturing.",
    description:
      "Rice Glucose Syrup from Pakistan is a clear, viscous sweetener derived from rice starch, used in confectionery, bakery, beverages and food processing. It offers a mild sweetness, excellent binding and a clean neutral flavour. Supplied in drums, IBC totes and bulk.",
    specs: [
      { label: "Type", value: "Rice-based glucose syrup" },
      { label: "Dry Solids", value: "80% to 82%" },
      { label: "DE (Dextrose Equivalent)", value: "38 to 42" },
      { label: "Appearance", value: "Clear, colourless to pale" },
    ],
    packaging: [
      "25kg and 300kg drums",
      "IBC totes",
      "Bulk / flexitank on request",
      "Custom DE grades available",
    ],
  },
  {
    slug: "vietnamese-white-rice",
    name: "Vietnamese White Rice",
    category: "non-basmati",
    origin: "Vietnam",
    image: WHITE_RICE,
    short: "Clean Vietnamese long grain white rice, 5% broken.",
    description:
      "Long grain white rice from Vietnam with a clean appearance and dependable cooking performance. Available in 5%, 15% and 25% broken grades to suit different markets.",
    specs: [
      { label: "Grain Type", value: "Long grain" },
      { label: "Type", value: "White" },
      { label: "Moisture", value: "14% max" },
      { label: "Broken", value: "5% / 15% / 25%" },
    ],
    packaging: ricePack,
  },
  {
    slug: "thai-jasmine-rice",
    name: "Thai Jasmine Rice",
    category: "non-basmati",
    origin: "Thailand",
    tag: "Popular",
    image: RICE_IMG2,
    short: "Fragrant Thai jasmine rice with a soft, aromatic grain.",
    description:
      "Premium Thai Hom Mali jasmine rice, celebrated for its natural fragrance and soft, slightly sticky texture. A favourite for retail and food service across the world.",
    specs: [
      { label: "Grain Type", value: "Long grain fragrant" },
      { label: "Type", value: "Jasmine (Hom Mali)" },
      { label: "Moisture", value: "14% max" },
      { label: "Purity", value: "92% min" },
    ],
    packaging: ricePack,
  },
  {
    slug: "myanmar-white-rice",
    name: "Myanmar White Rice",
    category: "non-basmati",
    origin: "Myanmar",
    image: BROKEN_RICE,
    short: "Economical Myanmar long grain white rice.",
    description:
      "Long grain white rice from Myanmar offering excellent value for high volume markets. Supplied in a range of broken grades to meet buyer requirements.",
    specs: [
      { label: "Grain Type", value: "Long grain" },
      { label: "Type", value: "White" },
      { label: "Moisture", value: "14% max" },
      { label: "Broken", value: "5% / 25% options" },
    ],
    packaging: ricePack,
  },
  {
    slug: "irri-6-long-grain-white-rice",
    name: "IRRI-6 Long Grain White Rice",
    category: "non-basmati",
    origin: "Pakistan",
    image: WHITE_RICE,
    short: "Economical long grain white rice for high volume markets.",
    description:
      "IRRI-6 is a dependable long grain non-basmati rice, valued for its consistency and value. A staple for importers, distributors and food processing companies.",
    specs: [
      { label: "Grain Type", value: "Long grain" },
      { label: "Type", value: "White / Parboiled" },
      { label: "Moisture", value: "14% max" },
      { label: "Broken", value: "5% / 10% / 25% options" },
    ],
    packaging: ricePack,
  },
  {
    slug: "pk-386-long-grain-white-rice",
    name: "PK-386 Long Grain White Rice",
    category: "non-basmati",
    origin: "Pakistan",
    image: WHITE_RICE,
    short: "Slender long grain non-basmati, versatile and economical.",
    description:
      "PK-386 is a slender, long grain white rice with a clean appearance and neutral flavour. Widely used across the Middle East and East Africa for everyday consumption.",
    specs: [
      { label: "Grain Type", value: "Long slender" },
      { label: "Type", value: "White" },
      { label: "Moisture", value: "14% max" },
      { label: "Broken", value: "5% to 10%" },
    ],
    packaging: ricePack,
  },
  // ---------------- WHEAT ----------------
  {
    slug: "milling-wheat",
    name: "Milling Wheat",
    category: "wheat",
    origin: "Black Sea & UAE",
    image: WHEAT_IMG,
    short: "Quality milling wheat for flour production.",
    description:
      "Sound, dry milling wheat with reliable protein content, cleaned and graded for flour mills and food manufacturers.",
    specs: [
      { label: "Type", value: "Milling grade" },
      { label: "Moisture", value: "12% max" },
      { label: "Protein", value: "11% to 12.5%" },
      { label: "Foreign Matter", value: "2% max" },
    ],
    packaging: bulkPack,
  },
  {
    slug: "feed-wheat",
    name: "Feed Wheat",
    category: "wheat",
    origin: "Black Sea",
    image: WHEAT_IMG,
    short: "Energy rich feed wheat for animal nutrition.",
    description:
      "Feed grade wheat supplied to feed manufacturers and livestock operations, offering a dependable energy source at competitive value.",
    specs: [
      { label: "Type", value: "Feed grade" },
      { label: "Moisture", value: "13% max" },
      { label: "Foreign Matter", value: "3% max" },
      { label: "Test Weight", value: "72 kg/hl min" },
    ],
    packaging: bulkPack,
  },
  // ---------------- FLOUR ----------------
  {
    slug: "wheat-flour",
    name: "Wheat Flour",
    category: "flour",
    origin: "UAE",
    tag: "New",
    image: IMG_FLOUR,
    short: "UAE milled wheat flour, atta and maida grades.",
    description:
      "Finely milled wheat flour produced in the UAE, available in white flour (maida), whole wheat (atta) and all-purpose grades. Consistent quality for bakeries, food manufacturers and retail.",
    specs: [
      { label: "Grades", value: "Maida, Atta, All-purpose" },
      { label: "Moisture", value: "13% max" },
      { label: "Protein", value: "10% to 12%" },
      { label: "Origin", value: "Milled in the UAE" },
    ],
    packaging: [
      "1kg, 2kg, 5kg, 10kg retail packs",
      "25kg and 50kg bags",
      "Bulk supply available",
      "Private label under your own brand",
    ],
  },
  // ---------------- CORN ----------------
  {
    slug: "yellow-corn-maize",
    name: "Yellow Corn Maize",
    category: "corn",
    origin: "Argentina & Brazil",
    image: CORN_IMG,
    short: "Feed grade yellow corn maize for animal nutrition.",
    description:
      "Feed grade yellow corn maize with bright colour and low moisture, an essential energy ingredient for poultry, cattle and aquaculture feed manufacturers.",
    specs: [
      { label: "Type", value: "Feed grade" },
      { label: "Moisture", value: "14% max" },
      { label: "Broken", value: "3% max" },
      { label: "Aflatoxin", value: "As per buyer spec" },
    ],
    packaging: bulkPack,
  },
  // ---------------- PULSES ----------------
  {
    slug: "green-lentils",
    name: "Green Lentils",
    category: "pulses",
    origin: "Canada",
    tag: "New",
    image: IMG_PULSES,
    short: "Premium Canadian green lentils, cleaned and sized.",
    description:
      "Whole green lentils sourced from Canada, machine cleaned and colour sorted for uniformity. A protein rich staple for retail, food service and processing.",
    specs: [
      { label: "Type", value: "Whole green lentils (Laird)" },
      { label: "Purity", value: "99% min" },
      { label: "Moisture", value: "13% max" },
      { label: "Screen Size", value: "As per buyer spec" },
    ],
    packaging: bulkPack,
  },
  {
    slug: "red-lentils",
    name: "Red Split Lentils",
    category: "pulses",
    origin: "Canada & India",
    image: IMG_PULSES,
    short: "Football and split red lentils, bright and clean.",
    description:
      "Red lentils supplied whole (football) or split (masoor dal), cleaned and polished for a bright, consistent appearance. A kitchen staple across South Asia and the Middle East.",
    specs: [
      { label: "Type", value: "Whole / Split (Masoor)" },
      { label: "Purity", value: "99% min" },
      { label: "Moisture", value: "13% max" },
      { label: "Foreign Matter", value: "0.5% max" },
    ],
    packaging: bulkPack,
  },
  {
    slug: "chickpeas",
    name: "Chickpeas (Kabuli)",
    category: "pulses",
    origin: "India & Turkey",
    image: IMG_PULSES,
    short: "Kabuli chickpeas in a range of calibres.",
    description:
      "Kabuli white chickpeas sourced from India and Turkey, available in a range of calibres (per ounce counts). Cleaned and sorted for food service, canning and retail.",
    specs: [
      { label: "Type", value: "Kabuli chickpeas" },
      { label: "Calibre", value: "7mm to 12mm" },
      { label: "Moisture", value: "12% max" },
      { label: "Purity", value: "99% min" },
    ],
    packaging: bulkPack,
  },
  // ---------------- SUGAR ----------------
  {
    slug: "refined-white-sugar-india",
    name: "Refined White Sugar (India)",
    category: "sugar",
    origin: "India",
    tag: "New",
    image: IMG_SUGAR,
    short: "Refined white sugar, ICUMSA 45, from India.",
    description:
      "Refined white cane sugar from India with fine, uniform crystals and high purity. ICUMSA 45 grade suitable for retail, food and beverage manufacturing.",
    specs: [
      { label: "Grade", value: "ICUMSA 45" },
      { label: "Colour", value: "Sparkling white" },
      { label: "Polarisation", value: "99.80% min" },
      { label: "Moisture", value: "0.04% max" },
    ],
    packaging: [
      "1kg, 2kg, 5kg retail packs",
      "25kg and 50kg PP bags",
      "Bulk jumbo bags",
      "Private label available",
    ],
  },
  {
    slug: "refined-cane-sugar-brazil",
    name: "Refined Cane Sugar (Brazil)",
    category: "sugar",
    origin: "Brazil",
    image: IMG_SUGAR,
    short: "Brazilian refined cane sugar, ICUMSA 45.",
    description:
      "Refined cane sugar from Brazil, ICUMSA 45 grade, with bright white crystals and excellent solubility. Available for bulk and containerised shipment worldwide.",
    specs: [
      { label: "Grade", value: "ICUMSA 45" },
      { label: "Colour", value: "Sparkling white" },
      { label: "Polarisation", value: "99.80% min" },
      { label: "Moisture", value: "0.04% max" },
    ],
    packaging: [
      "25kg and 50kg PP bags",
      "Bulk jumbo bags",
      "Loose bulk in containers",
      "Private label available",
    ],
  },
  // ---------------- EDIBLE OIL ----------------
  {
    slug: "rbd-palm-olein-indonesia",
    name: "RBD Palm Olein (Indonesia)",
    category: "oil",
    origin: "Indonesia",
    tag: "New",
    image: IMG_OIL,
    short: "Refined palm olein cooking oil from Indonesia.",
    description:
      "RBD palm olein from Indonesia, a clear, refined cooking oil ideal for frying and food manufacturing. Available in bottles, jerry cans, drums and flexitank.",
    specs: [
      { label: "Type", value: "RBD Palm Olein CP8 / CP10" },
      { label: "FFA", value: "0.1% max" },
      { label: "Moisture", value: "0.1% max" },
      { label: "Colour", value: "3 Red max" },
    ],
    packaging: [
      "1L, 2L, 5L bottles",
      "10L, 20L jerry cans",
      "Drums and flexitank",
      "Private label available",
    ],
  },
  {
    slug: "rbd-palm-oil-malaysia",
    name: "RBD Palm Oil (Malaysia)",
    category: "oil",
    origin: "Malaysia",
    image: IMG_OIL,
    short: "Refined palm oil from Malaysia for food industry.",
    description:
      "RBD palm oil from Malaysia, refined, bleached and deodorised for cooking and food processing. Supplied in flexible retail and bulk formats.",
    specs: [
      { label: "Type", value: "RBD Palm Oil" },
      { label: "FFA", value: "0.1% max" },
      { label: "Moisture", value: "0.1% max" },
      { label: "Melting Point", value: "As per spec" },
    ],
    packaging: [
      "1L, 5L bottles",
      "20L jerry cans",
      "Drums and flexitank",
      "Private label available",
    ],
  },
  // ---------------- SALT ----------------
  {
    slug: "himalayan-pink-salt",
    name: "Himalayan Pink Salt",
    category: "salt",
    origin: "Pakistan",
    tag: "Signature",
    image: SALT_IMG,
    short: "Naturally mined pink salt in grades from fine powder to rock.",
    description:
      "Himalayan Pink Salt, naturally mined and rich in trace minerals, is supplied in a full range of grades from fine table powder to coarse crystals and decorative rock. Ideal for food, wellness and private label brands.",
    specs: [
      { label: "Colour", value: "Light to dark pink" },
      { label: "Grades", value: "Powder, fine, coarse, rock, chunks" },
      { label: "Purity", value: "97% to 99% NaCl" },
      { label: "Form", value: "Edible, bath and lamp grade" },
    ],
    packaging: [
      "500g, 1kg, 5kg, 25kg packs",
      "Bulk jumbo bags for industrial buyers",
      "Consumer grinders and refill packs",
      "Private label under your own brand",
    ],
  },
  {
    slug: "refined-edible-white-salt",
    name: "Refined Edible White Salt",
    category: "salt",
    origin: "Pakistan",
    image: REFINED_SALT,
    short: "Refined, free flowing white salt for food use.",
    description:
      "Refined edible white salt with consistent grain size and high purity, suitable for table use, food processing and industrial applications.",
    specs: [
      { label: "Colour", value: "Pure white" },
      { label: "Purity", value: "99% NaCl min" },
      { label: "Moisture", value: "0.5% max" },
      { label: "Additives", value: "Iodised on request" },
    ],
    packaging: [
      "1kg, 25kg, 50kg bags",
      "Bulk supply available",
      "Consumer retail packs",
      "Private label under your own brand",
    ],
  },
  // ---------------- SESAME ----------------
  {
    slug: "natural-white-hulled-sesame-seeds",
    name: "Natural White Hulled Sesame Seeds",
    category: "sesame",
    origin: "Sudan & Nigeria",
    image: SESAME_IMG,
    short: "High purity hulled sesame seeds for the food industry.",
    description:
      "Natural white hulled sesame seeds with clean, uniform appearance and high oil content. Supplied to bakeries, confectioners and food processing companies worldwide.",
    specs: [
      { label: "Type", value: "Hulled, natural white" },
      { label: "Purity", value: "99.95% min" },
      { label: "Moisture", value: "5% max" },
      { label: "Oil Content", value: "48% to 52%" },
    ],
    packaging: [
      "25kg PP / paper bags",
      "Bulk jumbo bags",
      "Vacuum packs on request",
      "Private label available",
    ],
  },
  // ---------------- PASTA & NOODLES ----------------
  {
    slug: "pasta",
    name: "Pasta",
    category: "pasta",
    origin: "Turkey",
    tag: "New",
    image: IMG_PASTA,
    short: "Durum wheat pasta in assorted shapes from Turkey.",
    description:
      "Premium durum wheat semolina pasta produced in Turkey, available in a wide range of shapes and cuts. Consistent quality and cooking performance for retail and food service.",
    specs: [
      { label: "Made From", value: "100% durum wheat semolina" },
      { label: "Shapes", value: "Penne, fusilli, macaroni and more" },
      { label: "Shelf Life", value: "36 months" },
      { label: "Origin", value: "Turkey" },
    ],
    packaging: retailPack,
  },
  {
    slug: "spaghetti",
    name: "Spaghetti",
    category: "pasta",
    origin: "Turkey",
    image: IMG_PASTA,
    short: "Long durum wheat spaghetti from Turkey.",
    description:
      "Long, straight spaghetti made from 100% durum wheat semolina, produced in Turkey. Firm texture and reliable cooking for retail and catering markets.",
    specs: [
      { label: "Made From", value: "100% durum wheat semolina" },
      { label: "Length", value: "Standard long cut" },
      { label: "Shelf Life", value: "36 months" },
      { label: "Origin", value: "Turkey" },
    ],
    packaging: retailPack,
  },
  {
    slug: "instant-noodles",
    name: "Instant Noodles",
    category: "pasta",
    origin: "Turkey",
    image: IMG_PASTA,
    short: "Instant noodles in assorted flavours from Turkey.",
    description:
      "Instant noodles produced in Turkey, available in cup and pack formats and a range of flavours. Fast, convenient and well suited to retail and wholesale.",
    specs: [
      { label: "Format", value: "Pack and cup" },
      { label: "Flavours", value: "Assorted" },
      { label: "Shelf Life", value: "12 months" },
      { label: "Origin", value: "Turkey" },
    ],
    packaging: retailPack,
  },
  // ---------------- BEVERAGES ----------------
  {
    slug: "fruit-juices",
    name: "Fruit Juices",
    category: "beverages",
    origin: "Pakistan",
    tag: "New",
    image: IMG_BEVERAGES,
    short: "Assorted fruit juices and nectars from Pakistan.",
    description:
      "A range of fruit juices and nectars produced in Pakistan in assorted flavours and pack sizes. Suitable for retail, hospitality and wholesale distribution.",
    specs: [
      { label: "Type", value: "Juice and nectar" },
      { label: "Flavours", value: "Mango, apple, orange, mixed fruit" },
      { label: "Formats", value: "Tetra pack, bottle, can" },
      { label: "Origin", value: "Pakistan" },
    ],
    packaging: retailPack,
  },
  {
    slug: "carbonated-soft-drinks",
    name: "Carbonated Soft Drinks",
    category: "beverages",
    origin: "Pakistan",
    image: IMG_BEVERAGES,
    short: "Carbonated soft drinks in assorted flavours.",
    description:
      "Carbonated soft drinks produced in Pakistan across a variety of flavours and bottle sizes, packed for export to retail and wholesale markets.",
    specs: [
      { label: "Type", value: "Carbonated soft drinks" },
      { label: "Flavours", value: "Cola, lemon, orange and more" },
      { label: "Formats", value: "PET bottle and can" },
      { label: "Origin", value: "Pakistan" },
    ],
    packaging: retailPack,
  },
  // ---------------- CONFECTIONERY ----------------
  {
    slug: "candies-and-toffees",
    name: "Candies & Toffees",
    category: "confectionery",
    origin: "India & Pakistan",
    tag: "New",
    image: IMG_CONFECTIONERY,
    short: "Assorted hard candies and toffees for retail.",
    description:
      "A colourful range of hard candies, toffees and lollipops produced in India and Pakistan. Assorted flavours and formats for retail and wholesale confectionery buyers.",
    specs: [
      { label: "Type", value: "Hard candy, toffee, lollipop" },
      { label: "Flavours", value: "Assorted fruit and milk" },
      { label: "Formats", value: "Jars, pillow packs, cartons" },
      { label: "Origin", value: "India & Pakistan" },
    ],
    packaging: retailPack,
  },
  {
    slug: "bubble-gum",
    name: "Bubble Gum",
    category: "confectionery",
    origin: "India & Pakistan",
    image: IMG_CONFECTIONERY,
    short: "Assorted bubble gum in jars and display packs.",
    description:
      "Bubble gum produced in India and Pakistan in a variety of flavours, shapes and pack formats including center-filled gum, jars and countertop displays.",
    specs: [
      { label: "Type", value: "Bubble gum, center-filled" },
      { label: "Flavours", value: "Assorted fruit and mint" },
      { label: "Formats", value: "Jars and display boxes" },
      { label: "Origin", value: "India & Pakistan" },
    ],
    packaging: retailPack,
  },
  // ---------------- BISCUITS ----------------
  {
    slug: "biscuits",
    name: "Biscuits",
    category: "biscuits",
    origin: "Pakistan",
    tag: "New",
    image: IMG_BISCUITS,
    short: "Assorted biscuits and cookies from Pakistan.",
    description:
      "A wide assortment of biscuits and cookies produced in Pakistan, including plain, cream filled and sandwich varieties. Packed for retail and wholesale export.",
    specs: [
      { label: "Type", value: "Plain, cream, sandwich" },
      { label: "Flavours", value: "Assorted" },
      { label: "Shelf Life", value: "9 to 12 months" },
      { label: "Origin", value: "Pakistan" },
    ],
    packaging: retailPack,
  },
  // ---------------- MOLASSES ----------------
  {
    slug: "cane-molasses",
    name: "Cane Molasses",
    category: "molasses",
    origin: "Pakistan",
    tag: "New",
    image: IMG_MOLASSES,
    short: "Sugarcane molasses for feed and industrial use.",
    description:
      "Sugarcane molasses from Pakistan, a thick dark syrup used in animal feed, fermentation, distilleries and industrial applications. Supplied in flexitank and drums.",
    specs: [
      { label: "Type", value: "Cane molasses" },
      { label: "Brix", value: "79 to 85 degrees" },
      { label: "Total Sugars", value: "46% min" },
      { label: "Origin", value: "Pakistan" },
    ],
    packaging: [
      "Flexitank in containers",
      "IBC totes and drums",
      "Bulk vessel on request",
    ],
  },
  // ---------------- SPICES & MASALA ----------------
  {
    slug: "shayrar-ready-mix-masala-spices",
    name: "Shayrar Ready Mix Masala & Spices",
    category: "spices",
    origin: "Pakistan",
    tag: "Own Brand",
    image: IMG_SPICES,
    short: "Our own brand of ready-mix masalas and pure ground spices.",
    description:
      "Shayrar is our own house brand of ready-mix masalas and pure ground spices, blended and packed in Pakistan to authentic South Asian recipes. The range spans recipe blends such as biryani, karahi, chicken and meat masala, alongside single spices including red chilli, turmeric, coriander and cumin powder. Consistent flavour, vibrant colour and hygienic packing, available for retail and private label.",
    specs: [
      { label: "Brand", value: "Shayrar (our own brand)" },
      { label: "Range", value: "Ready-mix masalas & ground spices" },
      { label: "Blends", value: "Biryani, karahi, chicken, meat masala and more" },
      { label: "Single Spices", value: "Red chilli, turmeric, coriander, cumin" },
    ],
    packaging: [
      "Consumer sachets and boxes",
      "Retail pouches and jars",
      "Bulk packs for food service",
      "Private label available",
    ],
  },
  // ---------------- DATES ----------------
  {
    slug: "dry-dates-chuhara",
    name: "Dry Dates (Chuhara)",
    category: "dates",
    origin: "Pakistan",
    tag: "New",
    image: IMG_DATES,
    short: "Naturally dried hard dates (chuhara) from Pakistan.",
    description:
      "Dry dates, known as chuhara, are naturally sun-dried hard dates from Pakistan with a firm texture and long shelf life. A traditional favourite for festivals, confectionery and everyday snacking, supplied cleaned and graded for retail and wholesale.",
    specs: [
      { label: "Type", value: "Dry dates (Chuhara)" },
      { label: "Texture", value: "Hard, naturally dried" },
      { label: "Colour", value: "Golden to light brown" },
      { label: "Moisture", value: "As per grade" },
    ],
    packaging: [
      "5kg, 10kg cartons",
      "Consumer retail packs",
      "Bulk supply available",
      "Private label available",
    ],
  },
  // ---------------- FRESH PRODUCE ----------------
  {
    slug: "red-onion",
    name: "Red Onion",
    category: "produce",
    origin: "Pakistan",
    tag: "New",
    image: IMG_ONION,
    short: "Fresh export-grade red onions from Pakistan.",
    description:
      "Fresh red onions from Pakistan with firm bulbs, deep red-purple skin and pungent flavour. Carefully sorted and packed for export to wholesale and retail markets, with dependable shelf life for long-haul shipment.",
    specs: [
      { label: "Type", value: "Red onion" },
      { label: "Colour", value: "Deep red / purple" },
      { label: "Condition", value: "Fresh, firm, cured" },
      { label: "Origin", value: "Pakistan" },
    ],
    packaging: [
      "5kg, 10kg, 20kg mesh bags",
      "Jute and net sacks",
      "Ventilated cartons",
      "Bulk containers on request",
    ],
  },
  {
    slug: "potato",
    name: "Potato",
    category: "produce",
    origin: "Pakistan",
    tag: "New",
    image: IMG_POTATO,
    short: "Fresh export-grade potatoes from Pakistan.",
    description:
      "Fresh potatoes from Pakistan with smooth skin and firm flesh, suitable for table use and processing. Sorted, graded and packed for export, offering good storage life for wholesale and retail buyers worldwide.",
    specs: [
      { label: "Type", value: "Fresh potato" },
      { label: "Skin", value: "Smooth, light brown" },
      { label: "Condition", value: "Fresh, firm, cleaned" },
      { label: "Origin", value: "Pakistan" },
    ],
    packaging: [
      "10kg, 25kg mesh bags",
      "Jute and net sacks",
      "Ventilated cartons",
      "Bulk containers on request",
    ],
  },
  // ---------------- GROCERY ----------------
  {
    slug: "vermicelli",
    name: "Vermicelli",
    category: "grocery",
    origin: "Pakistan",
    tag: "New",
    image: IMG_VERMICELLI,
    short: "Roasted and plain vermicelli (seviyan) from Pakistan.",
    description:
      "Fine wheat vermicelli (seviyan) from Pakistan, available roasted and plain. A staple for desserts and breakfast dishes, packed for retail and wholesale.",
    specs: [
      { label: "Type", value: "Roasted / plain" },
      { label: "Made From", value: "Refined wheat flour" },
      { label: "Shelf Life", value: "12 months" },
      { label: "Origin", value: "Pakistan" },
    ],
    packaging: retailPack,
  },
  {
    slug: "pickles-achar",
    name: "Pickles (Achar)",
    category: "grocery",
    origin: "Pakistan",
    image: IMG_PICKLES,
    short: "Traditional mixed and mango pickles from Pakistan.",
    description:
      "Traditional South Asian pickles (achar) from Pakistan, including mango, mixed vegetable, lime and chilli, prepared in oil and spices. Packed in jars and pouches for retail.",
    specs: [
      { label: "Varieties", value: "Mango, mixed, lime, chilli" },
      { label: "Base", value: "Oil and spice" },
      { label: "Formats", value: "Glass jars and pouches" },
      { label: "Origin", value: "Pakistan" },
    ],
    packaging: retailPack,
  },
];

export const FEATURED_SLUGS = [
  "1121-sella-basmati-rice",
  "thai-jasmine-rice",
  "refined-white-sugar-india",
  "himalayan-pink-salt",
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
export const categoryLabel = (id) => CATEGORIES.find((c) => c.id === id)?.label || id;
